  <div class="common-text-input__container-field-sequential">
    <field-sequential-header [field]="field"></field-sequential-header>
    <div class="common-text-input__block-field-list-sequential"
      [ngClass]="{'common-text-input__block-field-list-sequential--focused': fieldTypeList.showList,
        'common-text-input__block-field-list-sequential--error': field.error }"
      [attr.disabled]="field.noEditable?true:null"
      #containerFieldList>
      <div class="common-dropdown-list__container-selected-list-sequential">
        @if(field.multiple && fieldTypeList.listElementSelect?.length){
          @for (listElement of fieldTypeList.listElementSelect; track $index){
            <div class="common-chips__standard"
                [attr.disabled]="field.noEditable?true:null">
                <span-tooltip class="common-chips__label-text-sequential"
                  [text]="listElement.text"></span-tooltip>
                @if (!field.noEditable){
                  <button class="lf-icon-close-round common-icon__sm common-chips__icon-close"
                    type="button"
                    (click)="addOrDeleteSelectedValue(listElement)"></button>
                }
            </div>
          }
        }@else if (fieldTypeList.selectItemName) {
          <span class="common-text-input__text-selected-element-list-sequential">{{fieldTypeList.selectItemName}}</span>
        }@else {
          <span class="common-text-input__placeholder-list-sequential"
            [afTranslate]="'common.select-value'">_Selecciona un valor</span>
        }
      </div>
      <div class="common-text-input__buttons-right-header">
        <div class="common-text-input__buttons-right-header-container">
          <button class="common-button__icon-sm-noborder"
            [disabled]="field.noEditable"
            (click)="toggleFilter($event)">
            <i class="common-icon__md"
              [ngClass]="fieldTypeList.showList ? 'lf-icon-angle-up' : 'lf-icon-angle-down'"></i>
          </button>
          @if(!field.noEditable){
            <p-overlayPanel #fieldTypeListSequentialOverlay
              styleClass="common-dropdown-list__overlay-field-list"
              (onShow)="fieldTypeList.showList = true"
              (onHide)="closeList()">
              <ng-template pTemplate="content">
                <div class="common-dropdown-list__overlay-field-list-container"
                  [ngStyle]="{'width': containerFieldListElement.nativeElement?.offsetWidth+'px'}">
                  <div class="common-dropdown-list__overlay-list-container">
                    @for (listValue of fieldTypeList.filterList | byWord:fieldTypeList.findDropdown:[fieldToFind] | afOrderBy:fieldTypeList.orderList:fieldTypeList.orderAsc; track $index) {
                      @if (checkListValue(listValue.type)) {
                        <div class="common-dropdown-list__user-item"
                          [attr.disabled]="listValue.disabled || field.noEditable?true:null"
                          (click)="addOrDeleteSelectedValue(listValue)">
                          <div class="common-button__block-button-md-checkbox">
                            <button class="common-button__icon-md-checkbox"
                              type="button"
                              [ngClass]="{'common-button__icon-md-checkbox--selected': listValue.selected}"
                              [disabled]="listValue.disabled || field.noEditable">
                              <i class="common-icon__md"
                                [ngClass]="{'lf-icon-check-full': field.multiple && listValue.selected,
                                  'lf-icon-box-inactive': field.multiple && !listValue.selected,
                                  'lf-icon-radio-button-active': !field.multiple && listValue.selected,
                                  'lf-icon-step-first': !field.multiple && !listValue.selected}"></i>
                            </button>
                          </div>
                          <div class="common-dropdown-list__user-item-wrapper">
                            <span-tooltip class="common-dropdown__list-text-title-sequential"
                              [text]="listValue.text"
                              [isDeleted]="listValue.isDeleted"></span-tooltip>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              </ng-template>
            </p-overlayPanel>
          }
        </div>
      </div>
    </div>
    @if(field.error){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
